import { env } from '@/env'
import { getIntl } from '@/locale/intl'

interface Params {
  titleKey?: string
  titleValue?: string | null
}

export const buildPageTitle = ({ titleKey, titleValue }: Params = {}) => {
  const intl = getIntl()
  const staticPart =
    titleKey && intl.messages[titleKey]
      ? intl.formatMessage({ id: titleKey })
      : undefined

  const core = [titleValue, staticPart].filter(Boolean).join(' - ').trim()
  const prefix = core ? `${core} | ` : ''
  const suffix = env.MODE === 'production' ? '' : ` [${env.MODE}]`

  return [prefix, env.APP_NAME ?? 'Masterplan', suffix].join('')
}
